import styled from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';

const CallToActionRoute = styled(LinkRouter)`
  color: #fff;
  background: linear-gradient(-45deg, #00a2ff, #c300ff, #ffabf4);

  text-decoration: none;
  padding: 10px 20px;
  border-radius: 50px;
  border: none;
  white-space: nowrap;
  cursor: pointer;
  transition: var(--transition);

  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 700;

  background-size: 600%;
  transition: all 0.3s ease-out;
  animation: animeGrad 8s linear infinite;

  &:hover {
    transform: scale(0.95);
  }

  &--gradient {
    position: absolute;
    margin-top: -70px;
    z-index: -1;
    filter: blur(10px);
    opacity: 0.8;
  }

  @keyframes animeGrad {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export { CallToActionRoute };
